import { ILogEntry } from "../../../../../../motw_core/Entity/ILogEntry";
import { GetAllGoalNames } from "./LogInputForm/LogInputFormHelpers";
import { GetTodaysLogEntries } from "./GetTodaysLogEntries";

export function GetGoalNamesLoggedToday(logEntries: ILogEntry[]) {
    const GetGoalNameFromEntryText = (entryText: string) => entryText.split(" ")[2];

    const allGoalNames = GetAllGoalNames();

    if (allGoalNames.length === 0) {
        return [];
    }

    const todaysLogEntries = GetTodaysLogEntries(logEntries);

    const goalNamesLoggedToday = todaysLogEntries
        .map(GetGoalNameFromEntryText)
        .filter((goalName) => allGoalNames.includes(goalName));

    return goalNamesLoggedToday;
}

